var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.833,
    height: 19,
    viewBox: "0 0 15.833 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash",
    transform: "translate(-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3606",
    "data-name": "Path 3606",
    d: "M17.042,3.167H14.587A3.965,3.965,0,0,0,10.708,0H9.125A3.965,3.965,0,0,0,5.246,3.167H2.792a.792.792,0,0,0,0,1.583h.792V15.042A3.963,3.963,0,0,0,7.542,19h4.75a3.963,3.963,0,0,0,3.958-3.958V4.75h.792a.792.792,0,0,0,0-1.583ZM9.125,1.583h1.583a2.38,2.38,0,0,1,2.24,1.583H6.885a2.38,2.38,0,0,1,2.24-1.583Zm5.542,13.458a2.375,2.375,0,0,1-2.375,2.375H7.542a2.375,2.375,0,0,1-2.375-2.375V4.75h9.5Z",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3607",
    "data-name": "Path 3607",
    d: "M9.792,16.333a.792.792,0,0,0,.792-.792v-4.75a.792.792,0,0,0-1.583,0v4.75A.792.792,0,0,0,9.792,16.333Z",
    transform: "translate(-1.458 -2.083)",
    fill: "#c8102e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3608",
    "data-name": "Path 3608",
    d: "M13.792,16.333a.792.792,0,0,0,.792-.792v-4.75a.792.792,0,0,0-1.583,0v4.75A.792.792,0,0,0,13.792,16.333Z",
    transform: "translate(-2.292 -2.083)",
    fill: "#c8102e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.c73f80294f7acb815be4ae44ec4016d6.svg";
export { ForwardRef as ReactComponent };